import { Outlet, Navigate } from "react-router-dom";

const AccountingRoutes = (props) => {
   return props.arsomaUser ? <Outlet /> : <Navigate to="/login" />;
};

export default AccountingRoutes;
